/**
 * GeChiUI dependencies
 */
import { createSlotFill } from '@gechiui/components';

const { Fill, Slot } = createSlotFill( '__unstableAutocompletionItemsSlot' );

export {
	Fill as __unstableAutocompletionItemsFill,
	Slot as __unstableAutocompletionItemsSlot,
};
